import React from 'react';
import { View } from 'react-native';

import { measureView } from './useMeasuredView.utils';

import type { MeasureViewProps } from './useMeasuredView.types';

export const MeasuredView = (props: MeasureViewProps) => {
  const { initialMeasureOnly, width, height, setWidth, setHeight } = props;
  const reference = React.useRef<View>(null);
  const onLayout = React.useCallback(() => {
    measureView({
      // @ts-expect-error error TS2322: Type 'RefObject<View | null>' is not a
      reference,
      initialMeasureOnly,
      width,
      height,
      setWidth,
      setHeight,
    });
  }, [reference, initialMeasureOnly, width, height, setWidth, setHeight]);

  return <View ref={reference} onLayout={onLayout} {...props} />;
};
